/**
 * 
 * @param {*} str val
 * @param {*} decimalFormat number for decimal allow
 * @param {*} isDecimal is decimal or not
 * @returns 
 */
export const isNumberValue = (str, isDecimal = true, decimalFormat = 2) => {
  let regex = "";
  if (isDecimal) {
    regex = new RegExp(`^\\d+(\\.\\d{1,${decimalFormat}})?$`);
    // regex = /^\d+(\.\d{1,2})?$/;
  } else {
    regex = /^[0-9]*$/;
  }
  return regex.test(str);
};

export const isValidValue = (str, isDecimal = true, decimalFormat = 2) => {
  const isNumber = isNumberValue(str, isDecimal, decimalFormat);
  const regex = /^[a-zA-Z]+$/;
  return isNumber || regex.test(str);
};
